import { render, staticRenderFns } from "./CircuitModeSection.vue?vue&type=template&id=80c6267a&scoped=true"
import script from "./CircuitModeSection.vue?vue&type=script&lang=ts"
export * from "./CircuitModeSection.vue?vue&type=script&lang=ts"
import style0 from "./CircuitModeSection.vue?vue&type=style&index=0&id=80c6267a&prod&lang=scss&scoped=true"
import style1 from "./CircuitModeSection.vue?vue&type=style&index=1&id=80c6267a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c6267a",
  null
  
)

export default component.exports